import { render, staticRenderFns } from "./SelectDebrisType.vue?vue&type=template&id=8d83b680&"
import script from "./SelectDebrisType.vue?vue&type=script&lang=js&"
export * from "./SelectDebrisType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports